module.exports = __webpack_public_path__ + "html/transactions.component.html";